import { m } from 'framer-motion';
// @mui
import { Box, Container, Grid, Typography } from '@mui/material';
// components
import Image from '../../components/Image';
import { MotionViewport, varFade } from '../../components/animate';

// ----------------------------------------------------------------------

export default function AboutVision() {
  return (
    <Container component={MotionViewport} sx={{ mt: 2 }}>
      <Box
        sx={{
          mb: 2,
          position: 'relative',
          borderRadius: 2,
          overflow: 'hidden',
        }}
      >
        <Image
          src="/team/team.jpg"
          alt="about-vision"
          effect="black-and-white"
        />
        <Box
          sx={{
            bottom: { xs: 24, md: 80 },
            width: '100%',
            display: 'flex',
            flexWrap: 'wrap',
            alignItems: 'center',
            position: 'absolute',
            justifyContent: 'center',
          }}
        />
      </Box>
      <Grid container justifyContent="center">
        <Grid item xs={12} sm={12}>
          <m.div variants={varFade().inUp}>
            <Typography variant="h3" sx={{ textAlign: 'center' }}>
              Chúng tôi cung cấp sản phẩm giáo dục
            </Typography>
          </m.div>
        </Grid>
      </Grid>
    </Container>
  );
}
